import {ScheduleEntryInput} from "@/components/form/maintenance/types.ts";
import {ScheduleState} from "@/lib/types/checks.ts";

export interface ContactGroupBase {
  id: number;
  name: string;
}

export const PENDING_CONTACT_ID = 0;

export interface ContactGroupBaseItems {
  items: ContactGroupBase[];
  total: number;
}

export interface ContactGroup extends ContactGroupBase {
  id: number;
  name: string;
  email_list: string[];
  phonecall_list: string[];
  sms_list: string[];
  whatsapp_list: string[];
  up_alerts_email_only: boolean;
  num_services: number;
  num_escalations: number;
  integrations: number[];
  push_notifications?: number[];
  schedule_state: ScheduleState;
  schedule_entries: ScheduleEntryInput[];
  push_notification_profiles: number[];
}

export interface UpdateContactGroupInput extends Omit<
  ContactGroup,
  "id" | "num_services" | "num_escalations" | "push_notifications" | "schedule_state"
> {
  id?: number;
  push_notification_profiles: number[];
  schedule_state?: ScheduleState;
}
